import { Tooltip } from "@mui/material";
import type { ReactElement } from "react";
import { OPERATIONAL_WRITES_LOCKED_MESSAGE } from "@/shared/hooks/useOperationalWritesLocked";

type Props = {
	locked: boolean;
	fullWidth?: boolean;
	children: ReactElement;
};

// Wraps a disabled write action with the pre-cutover tooltip. The span keeps
// hover events alive on disabled MUI controls, which have pointer-events off.
export const WriteLockTooltip = ({ locked, fullWidth, children }: Props) => {
	if (!locked) return children;
	return (
		<Tooltip title={OPERATIONAL_WRITES_LOCKED_MESSAGE}>
			<span
				style={
					fullWidth
						? { display: "flex", width: "100%" }
						: { display: "inline-flex" }
				}
			>
				{children}
			</span>
		</Tooltip>
	);
};
